import styled from 'styled-components';
import { firefox, ie, mobile, big } from '../../../../styles/variables';

export const Wrapper = styled.aside<{ background?: string }>`
    display: flex;
    flex: 0 0 260px;
    overflow: hidden;
    background-image: url(${({ background }) => background});
    background-repeat: no-repeat;
    background-position: 100%;
    background-size: auto 100%;
    z-index: 2;

    @media ${big} {
        width: 0 0 336px;
    }

    @media ${mobile} {
        display: none;
    }
`;

export const AsideLayout = styled.div<{ isDark?: boolean }>`
    display: flex;
    flex-flow: column;
    color: white;
    font-size: 1rem;
    padding: 0 1rem;
    overflow-y: auto;
    /* backdrop-filter: blur(25px); */
    background-color: ${({ isDark }) => {
        const c = isDark ? 0 : 255,
            o = isDark ? 0.35 : 0.15;
        return `rgba(${c}, ${c}, ${c}, ${o})`;
    }};

    @media ${firefox} {
        background-color: rgba(0, 0, 0, 0.75);
    }

    @media ${ie} {
        padding: 1rem 1rem 1rem;
    }
`;

export const Heading = styled.div<{ withPadding?: boolean }>`
    font-size: 0.9rem;
    font-family: Bold;
    text-transform: uppercase;
    margin-bottom: 0.6rem;
    margin-top: ${({ withPadding }) => (withPadding ? '1.2rem' : 0)};
`;

export const Section = styled.section`
    margin: 1rem 0 1.5rem;
    font-size: 0.8rem;
`;

// @ts-ignore
export const BottomSection = styled(Section)`
    margin-top: auto;
`;
